/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import { GlobalSearchIcon } from "@dotnet/telematics-design-system";

import { MenuAnchorEl, useMediaQueries } from "../../../../shared";
import Button from "../../../Button/Button";
import { useStyles } from "../../styles";
import DesktopFindDevice from "./components/DesktopFindDevice/DesktopFindDevice";
import MobileFindDevice from "./components/MobileFindDevice/MobileFindDevice";

const FindDevice = () => {
  const { to899, toMd } = useMediaQueries();
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState<MenuAnchorEl>(null);
  const [isMobileDialogOpen, setIsMobileDialogOpen] = useState<boolean>(false);

  const { navbarButtonTitle } = useStyles();

  const handleOpenMobileDialog = () => {
    setIsMobileDialogOpen(true);
  };

  const handleOpenDesktopDialog = (e: {
    currentTarget: SetStateAction<MenuAnchorEl>;
  }) => {
    setOpenDialog(e.currentTarget);
  };

  const handleCloseDesktopDialog = () => {
    setOpenDialog(null);
  };

  const handleCloseMobileDialog = () => {
    setIsMobileDialogOpen(false);
  };

  return (
    <>
      {/* button turns into icon only on wider screen then to Md, but mobile dialog is shown only toMd screen */}
      {toMd || to899 ? (
        <Button
          data-testid="find-device-button-to-899"
          variant="iconOnly"
          size="small"
          color="white"
          onClick={toMd ? handleOpenMobileDialog : handleOpenDesktopDialog}
          icon={<GlobalSearchIcon />}
          css={css({ marginleft: "4px" })}
        />
      ) : (
        <Button
          data-testid="find-device-button-from-899"
          color="white"
          variant="iconLeft"
          size="small"
          icon={<GlobalSearchIcon />}
          onClick={handleOpenDesktopDialog}
        >
          <Typography variant="body2Medium" css={css(navbarButtonTitle)}>
            {t("Button##find device")}
          </Typography>
        </Button>
      )}
      {toMd ? (
        <MobileFindDevice
          isOpen={isMobileDialogOpen}
          onClose={handleCloseMobileDialog}
        />
      ) : (
        <DesktopFindDevice
          onClose={handleCloseDesktopDialog}
          anchorEl={openDialog}
        />
      )}
    </>
  );
};

export default FindDevice;
